import debounce from "lodash/debounce";
export default (sendToGraphElement, blockIdPrefix, nodeIdAttribute, nodeGroupIdAttribute, documentId, documentObjects, onTextSendToGraph) => {
    let sendToGraphClickCallback;
    const selectionChangeCallback = debounce(() => {
        var _a, _b;
        if (!documentId || !documentObjects || !onTextSendToGraph || !sendToGraphElement)
            return;
        sendToGraphClickCallback &&
            sendToGraphElement.removeEventListener("click", sendToGraphClickCallback);
        const selectionData = window.getSelection();
        if (!selectionData || selectionData.isCollapsed) {
            sendToGraphElement.setAttribute("disabled", "disabled");
            return;
        }
        const block = (_b = (_a = selectionData.focusNode) === null || _a === void 0 ? void 0 : _a.parentElement) === null || _b === void 0 ? void 0 : _b.closest(`[id^=${blockIdPrefix}]`);
        if (!block) {
            sendToGraphElement.setAttribute("disabled", "disabled");
            return;
        }
        const selectionText = selectionData.toString();
        sendToGraphElement.removeAttribute("disabled");
        sendToGraphClickCallback = () => {
            onTextSendToGraph(documentId, selectionText, documentObjects, nodeIdAttribute ? block.getAttribute(nodeIdAttribute) || undefined : undefined, nodeGroupIdAttribute ? block.getAttribute(nodeGroupIdAttribute) || undefined : undefined);
        };
        sendToGraphElement.addEventListener("click", sendToGraphClickCallback);
    }, 100);
    document.addEventListener("selectionchange", selectionChangeCallback);
    return () => {
        selectionChangeCallback &&
            document.removeEventListener("selectionchange", selectionChangeCallback);
    };
};
